import { TZ } from '../../config/index';
import AllocationRequest from '../../Modules/allocationRequest/models/allocationRequest.model';
import Availability from '../../Modules/availabilityManagement/models/availability.model';
import { AvailableStatusEnum } from '../../Modules/Labour/interfaces/labour.interface';
import Labour from '../../Modules/Labour/models/labour.model';
import mongoose from 'mongoose';
import cron from 'node-cron';


export class startAvailabilityCleanupJob {
    public start() {

        cron.schedule('0 0 * * *', async () => {
            const session = await mongoose.startSession();
            try {
                session.startTransaction();
                console.log('⏰ Running Availability Cleanup');

                const now = new Date();

                const expiredAvailabilities = await Availability.find({
                    endDate: { $lt: now },
                    isDeleted: false,
                    status: { $regex: `^${AvailableStatusEnum.UNAVAILABLE}$`, $options: 'i' },
                }).session(session);

                const availabilityIds = expiredAvailabilities.map(a => a._id);
                const userIdsFromAvailability = expiredAvailabilities.map(a => a.userId.toString());

                if (availabilityIds.length > 0) {
                    await Availability.updateMany(
                        { _id: { $in: availabilityIds } },
                        { $set: { isDeleted: true, deletedAt: now } },
                        { session }
                    );
                }

                const expiredRequests = await AllocationRequest.find({
                    endDate: { $lt: now },
                    isDeleted: false,
                }).session(session);

                const allocationRequestIds = expiredRequests.map(r => r._id);
                const userIdsFromAllocation = expiredRequests.map(r => r.userId.toString());

                if (allocationRequestIds.length > 0) {
                    await AllocationRequest.updateMany(
                        { _id: { $in: allocationRequestIds } },
                        { $set: { isDeleted: true, deletedAt: now } },
                        { session }
                    );
                }

                const affectedUserIds = [...new Set([...userIdsFromAvailability, ...userIdsFromAllocation])];

                for (const userId of affectedUserIds) {
                    const labour = await Labour.findOne({ userId, isDeleted: false }).session(session);
                    if (!labour) continue;

                    const validAvailabilityIds = await Availability.find({
                        _id: { $in: labour.availability },
                        isDeleted: false,
                    }).session(session).distinct('_id');

                    const invalidAvailabilityIds = labour.availability.filter(
                        id => !validAvailabilityIds.map(id => id.toString()).includes(id.toString())
                    );

                    const validAllocationIds = await AllocationRequest.find({
                        _id: { $in: labour.allocationRequest },
                        isDeleted: false,
                    }).session(session).distinct('_id');

                    const invalidAllocationIds = labour.allocationRequest.filter(
                        id => !validAllocationIds.map(id => id.toString()).includes(id.toString())
                    );

                    const update: any = {};
                    if (invalidAvailabilityIds.length > 0) {
                        update.$pull = { availability: { $in: invalidAvailabilityIds } };
                    }
                    if (invalidAllocationIds.length > 0) {
                        update.$pull = { ...(update.$pull || {}), allocationRequest: { $in: invalidAllocationIds } };
                    }

                    if (Object.keys(update).length > 0) {
                        await Labour.updateOne({ _id: labour._id }, update, { session });
                        console.log(`🧹 Cleaned Labour ${labour._id}: removed invalid refs`);
                    }

                    const unavailableCount = await Availability.countDocuments({
                        userId,
                        status: { $regex: `^${AvailableStatusEnum.UNAVAILABLE}$`, $options: 'i' },
                        isDeleted: false,
                    }).session(session);

                    if (unavailableCount === 0) {
                        await Labour.updateOne(
                            { userId, isDeleted: false },
                            { $set: { availability_status: AvailableStatusEnum.AVAILABLE } },
                            { session }
                        );
                    }
                }

                await session.commitTransaction();
                console.log('✅ Availability & Allocation cleanup (reliable mode) completed');
            } catch (error) {
                await session.abortTransaction();
                console.error('❌ Error in cleanup job:', error);
            } finally {
                session.endSession();
            }
        },
            { timezone: TZ });
    };
}


// import AllocationRequest from 'Modules/allocationRequest/models/allocationRequest.model';
// import Availability from 'Modules/availabilityManagement/models/availability.model';
// import { AvailableStatusEnum } from 'Modules/Labour/interfaces/labour.interface';
// import Labour from 'Modules/Labour/models/labour.model';
// import mongoose from 'mongoose';
// import cron from 'node-cron';

// export const startAvailabilityCleanupJob = () => {
//     cron.schedule('* * * * *', async () => {
//         const session = await mongoose.startSession();
//         try {
//             session.startTransaction();

//             const labours = await Labour.find({ isDeleted: false }).select('userId availability allocationRequest').lean().session(session);

//             for (const labour of labours) {
//                 const { userId, availability = [], allocationRequest = [] } = labour;

//                 const [validAvailabilityIds, validAllocationIds] = await Promise.all([
//                     Availability.find({
//                         _id: { $in: availability },
//                         isDeleted: false
//                     }).session(session).distinct('_id'),

//                     AllocationRequest.find({
//                         _id: { $in: allocationRequest },
//                         isDeleted: false
//                     }).session(session).distinct('_id'),
//                 ]);

//                 const validAvailabilitySet = new Set(validAvailabilityIds.map(id => id.toString()));
//                 const validAllocationSet = new Set(validAllocationIds.map(id => id.toString()));

//                 const invalidAvailabilityIds = availability.filter(id => !validAvailabilitySet.has(id.toString()));
//                 const invalidAllocationIds = allocationRequest.filter(id => !validAllocationSet.has(id.toString()));

//                 const updateOps: any = {};
//                 if (invalidAvailabilityIds.length > 0) {
//                     updateOps.$pull = { availability: { $in: invalidAvailabilityIds } };
//                 }
//                 if (invalidAllocationIds.length > 0) {
//                     updateOps.$pull = {
//                         ...(updateOps.$pull || {}),
//                         allocationRequest: { $in: invalidAllocationIds },
//                     };
//                 }

//                 // Apply clean-up
//                 if (Object.keys(updateOps).length > 0) {
//                     await Labour.updateOne({ userId }, updateOps, { session });
//                     console.log(`🧹 Cleaned Labour [userId: ${userId}] references`);
//                 }

//                 // Update availability_status if no active "Unavailable" left
//                 const activeUnavailableCount = await Availability.countDocuments({
//                     userId,
//                     isDeleted: false,
//                     status: { $regex: `^${AvailableStatusEnum.UNAVAILABLE}$`, $options: 'i' },
//                 }).session(session);

//                 if (activeUnavailableCount === 0) {
//                     await Labour.updateOne(
//                         { userId, isDeleted: false },
//                         { $set: { availability_status: AvailableStatusEnum.AVAILABLE } },
//                         { session }
//                     );
//                 }
//             }

//             await session.commitTransaction();
//             console.log('✅ Full Labour reference cleanup completed');
//         } catch (err) {
//             await session.abortTransaction();
//             console.error('❌ Error in Labour reference cleanup:', err);
//         } finally {
//             session.endSession();
//         }
//     });
// };



